import React from 'react';
import styles from './item.module.css';

export default ({ data }: { data: { name: string; nav_url: string } }) => {
  return (
    <>
      <a className={styles.item} href={data.nav_url} id={data.name === '我的' && styles.mine}>
        {data.name}
      </a>
    </>
  );
};
